'use client';
import Link from'./Link';
import { twMerge } from 'tailwind-merge';

interface HeaderMenuItemProps {
  href: string;
  text: string;
  isActive?: boolean;
  className?: string;
}

const HeaderMenuItem = ({ 
  href, 
  text, 
  isActive = false,
  className 
}: HeaderMenuItemProps) => {
  return (
    <Link data-component-id="src/components/ui/HeaderMenuItem.tsx:19:4" data-component-path="src/components/ui/HeaderMenuItem.tsx" data-component-line="19" data-component-end-line="28" data-component-file="HeaderMenuItem.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%7D"
      href={href}
      text={text}
      className={twMerge(
        'px-[34px] py-[22px] text-xs font-bold leading-tight tracking-[2px] uppercase transition-all duration-200 hover:bg-secondary-light',
        isActive ? 'bg-secondary-light text-text-primary' : 'text-text-primary hover:text-accent-color',
        className
      )}
      style={{ fontFamily: 'Oxanium' }}
    />
  )
}

export default HeaderMenuItem